import React from 'react';

import { ReactComponent } from '../../../../../shared/abstract/infrastructrue/ReactComponent';
import { TUserMoveFormComponent } from '../../../domain/interfaces';
import { TUserMoveFormView, UserMoveFormView } from './UserMoveForm.view';

export class UserMoveFormComponent extends ReactComponent {
  public static create = (
    payload: TUserMoveFormComponent,
  ): React.ReactElement<TUserMoveFormView> => {
    const { userPrincipal } = payload;

    return ReactComponent.withAnyOfPermissionsHOC<TUserMoveFormView>(
      ['system-admin:create:users', 'SAVE_USER_ROLES'],
      UserMoveFormView,
      {
        ...payload,
        user: userPrincipal,
      },
    );
  };
}
